import { useStorefrontTenantSlug } from '@/contexts/StorefrontTenantContext'
import { useReferenceStore } from '@/storefront/context/ReferenceStoreContext'

/**
 * Returns the path prefix for storefront internal links.
 * - On the main domain: "/ref/:storeSlug"
 * - On a tenant subdomain:  "" (empty — routes start at root)
 */
export function useStorefrontBase(): string {
  const { storeSlug, storefrontPathPrefix } = useReferenceStore()
  const tenantSlug = useStorefrontTenantSlug()
  if (tenantSlug) return ''
  const refBase = `/ref/${storeSlug}`
  return storefrontPathPrefix ? `${storefrontPathPrefix}${refBase}` : refBase
}
